// extracted by mini-css-extract-plugin
export var dropdownContainer = "_6p-5";
export var imageContainer = "_6p-4";
export var metricsGrid = "_6p-2";
export var productDetailContainer = "_6p-1";
export var productListContainer = "_6p-0";
export var subscriberTableContainer = "_6p-3";